import { CommonModule, DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { EmptyStateComponent } from '../../../../../../shared/components/empty-state/empty-state.component';
import { LoadingBoxComponent } from '../../../../../../shared/components/loading-box/loading-box.component';
import { AbntPipe } from '../../../../../../shared/pipes/abnt.pipe';
import { AlertService, AlertType } from '../../../../../../shared/services/alert.service';
import { FluxoCaixaService } from '../../../../../../shared/services/apis/financas/fluxo-caixa.service';
import { FluxoCaixaDetalheDiarioRequest } from '../../../../../../shared/services/requests/financas/fluxo-caixa-detalhe-diario.request';
import { FluxoCaixaDetalheDiarioItem } from '../../../../../../shared/services/responses/financas/fluxo-caixa.response';

export interface FluxoCaixaDetalheDiarioDialogData {
    filtros: FluxoCaixaDetalheDiarioRequest;
    /** Rótulo do tipo já resolvido pelo chamador — ex.: "Recebimentos", "Transferências de Saída". */
    tituloTipo: string;
    /** Data já formatada (dd/MM/yyyy) pra exibir no subtítulo, sem repetir o parse aqui. */
    dataLabel: string;
}

@Component({
    selector: 'app-fluxo-caixa-detalhe-diario-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        EmptyStateComponent,
        LoadingBoxComponent,
        AbntPipe,
        DatePipe
    ],
    providers: [DatePipe],
    templateUrl: './fluxo-caixa-detalhe-diario-dialog.component.html',
    styleUrl: './fluxo-caixa-detalhe-diario-dialog.component.css'
})
export class FluxoCaixaDetalheDiarioDialogComponent implements OnInit {
    public isLoading = false;
    public itens: FluxoCaixaDetalheDiarioItem[] = [];
    public readonly displayedColumns = ['descricao', 'categoria', 'valor'];

    constructor(
        public dialogRef: MatDialogRef<FluxoCaixaDetalheDiarioDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FluxoCaixaDetalheDiarioDialogData,
        private fluxoCaixaService: FluxoCaixaService,
        private alertService: AlertService
    ) { }

    ngOnInit(): void {
        this.buscarDetalhe();
    }

    private buscarDetalhe(): void {
        this.isLoading = true;
        this.fluxoCaixaService.getDetalheDiario(this.data.filtros).subscribe({
            next: res => {
                this.isLoading = false;
                if (res.isError) {
                    this.alertService.show('Erro', res.errorDescription, AlertType.error);
                    return;
                }
                this.itens = res.itens ?? [];
            },
            error: () => {
                this.isLoading = false;
                this.alertService.show('Erro', 'Não foi possível carregar o detalhamento do lançamento.', AlertType.error);
            }
        });
    }

    public get valorTotal(): number {
        return this.itens.reduce((soma, item) => soma + item.valor, 0);
    }

    // Descrição da movimentação pode conter HTML rico (mesmo padrão de observacoesHtml em outras telas) —
    // exibir só o texto puro na lista de detalhamento.
    public stripHtml(value: string | null | undefined): string {
        if (!value) return '—';
        const clean = value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        return clean || '—';
    }

    public fechar(): void {
        this.dialogRef.close();
    }
}
